import request from "@/lib/api/handler";
import { User } from "@/queries/user/profile";
import { QueryKeys } from "@/queries/utils";
import { setUser } from "@/redux/features/authSlice";
import { useAppDispatch } from "@/redux/hooks";
import { useReqType } from "@/stores/req-type";

import { useAuth0 } from "@auth0/auth0-react";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useAcceptTermsOfService = () => {
  const qc = useQueryClient();
  const { getAccessTokenSilently } = useAuth0();
  const dispatch = useAppDispatch();

  const setReqType = useReqType((s) => s.setReqType);

  const { mutate, isPending, error } = useMutation({
    mutationFn: async () => {
      const token = await getAccessTokenSilently();

      return request<User>({
        method: "POST",
        path: `/api/user/terms-of-service/accept`,
        token,
      });
    },
    onSuccess: (data) => {
      void dispatch(setUser(data));
      qc.setQueryData(QueryKeys.myProfile, data);
      setReqType(data);
    },
  });

  return {
    acceptTermsOfService: mutate,
    isAcceptingTermsOfService: isPending,
    acceptTermsOfServiceError: error,
  };
};
